import { useState } from 'react'
import { apiGet } from 'tennders-stracture/libs/api'

const useBankAccounts = () => {
  const [bankAccounts, setBankAccounts] = useState([])

  const fetchBankAccounts = async () => {
    try {
      const data = await apiGet('/finance/bank-accounts')
      setBankAccounts(data.map(bankAccount => ({ ...bankAccount, label: bankAccount.iban })))
    } catch (error) {
      // handle catch
    }
  }
  return { bankAccounts, fetchBankAccounts }
}

export default useBankAccounts
